import { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal, message } from 'antd'
import MyInput from '../../../components/forms/input'
import MyDatePicker from '../../../components/forms/datePicker'

const EditAlmamaterVisitCategory = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})

  useEffect(() => {
    axios.post('/p/almamater_visit/category/detail/get', {
      merchant_oid: merchantOid,
      category_oid: props.data.oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setFormValue(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }, [merchantOid, props.data])

  const handleOk = () => {
    setErrorMsg({})
    if (!formValue.name) {
      setErrorMsg({nameEmpty: '母校行分类名称不能为空'})
      return false
    }

    axios.post('/p/almamater_visit/category/edit', { 
      merchant_oid: merchantOid, 
      category_oid: formValue.oid, 
      name: formValue.name,
      start_time: formValue.start_time,
      end_time: formValue.end_time
    })
      .then(function (response) {
        if (response.errcode === 0) {
          handleCancel()
          props.getAlmamaterVisitCategoryList()
          message.success('修改成功！')
        } else {
          message.error(response.msg)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleCancel = () => {
    setErrorMsg({})
    props.isCancel()
  }

  return (
    <Modal 
      title={`编辑母校行分类<${formValue.oid}>`}
      destroyOnClose={true}
      width='700px'
      open={props.isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      cancelText="取消"
      okText="保存">

      <MyInput
        id="name"
        required
        autoFocus
        maxLength={64}
        label='名称'
        placeholder='请输入母校行分类的名称'
        value={formValue.name}
        onChange={setFormValue}
        errorMsg={errorMsg.nameEmpty}
      />

      <MyDatePicker
        id="start_time"
        label='开始时间'
        placeholder='选择时间'
        value={formValue.start_time}
        onChange={setFormValue}
        styles={{width: '360px'}}
        showTime
      />

      <MyDatePicker
        id="end_time"
        label='结束时间'
        placeholder='选择时间'
        value={formValue.end_time}
        onChange={setFormValue}
        styles={{width: '360px'}}
        showTime
      />
    </Modal>
  )
}
export default EditAlmamaterVisitCategory
